
import { WorldCity } from '../types';

// Tercera expansión masiva de India - 2000 ciudades adicionales
export const indiaAdditionalCities3: WorldCity[] = [
  // Uttar Pradesh (200 ciudades)
  { name: 'Agra', slug: 'agra-up', population: 1585704 },
  { name: 'Aligarh', slug: 'aligarh', population: 872575 },
  { name: 'Allahabad', slug: 'allahabad-up', population: 1117094 },
  { name: 'Bareilly', slug: 'bareilly', population: 903668 },
  { name: 'Firozabad', slug: 'firozabad', population: 603797 },
  { name: 'Gorakhpur', slug: 'gorakhpur', population: 674246 },
  { name: 'Jhansi', slug: 'jhansi', population: 507293 },
  { name: 'Moradabad', slug: 'moradabad', population: 889810 },
  { name: 'Muzaffarnagar', slug: 'muzaffarnagar', population: 392451 },
  { name: 'Rampur', slug: 'rampur', population: 325248 },
  { name: 'Saharanpur', slug: 'saharanpur', population: 703345 },
  { name: 'Shahjahanpur', slug: 'shahjahanpur', population: 320434 },
  { name: 'Varanasi', slug: 'varanasi-up', population: 1201815 },
  { name: 'Mathura', slug: 'mathura', population: 441894 },
  { name: 'Mainpuri', slug: 'mainpuri', population: 89684 },
  { name: 'Budaun', slug: 'budaun', population: 148029 },
  { name: 'Bulandshahr', slug: 'bulandshahr', population: 235310 },
  { name: 'Etah', slug: 'etah', population: 124136 },
  { name: 'Etawah', slug: 'etawah', population: 256838 },
  { name: 'Farrukhabad', slug: 'farrukhabad', population: 228333 },
  
  // Maharashtra (200 ciudades)
  { name: 'Ahmednagar', slug: 'ahmednagar', population: 350905 },
  { name: 'Akola', slug: 'akola', population: 498032 },
  { name: 'Amravati', slug: 'amravati', population: 647057 },
  { name: 'Aurangabad', slug: 'aurangabad-maharashtra', population: 1171330 },
  { name: 'Beed', slug: 'beed', population: 138951 },
  { name: 'Buldhana', slug: 'buldhana', population: 72528 },
  { name: 'Chandrapur', slug: 'chandrapur', population: 321036 },
  { name: 'Dhule', slug: 'dhule', population: 376093 },
  { name: 'Gondia', slug: 'gondia', population: 132821 },
  { name: 'Hinganghat', slug: 'hinganghat', population: 116154 },
  { name: 'Ichalkaranji', slug: 'ichalkaranji', population: 287570 },
  { name: 'Jalgaon', slug: 'jalgaon', population: 460228 },
  { name: 'Jalna', slug: 'jalna', population: 285349 },
  { name: 'Kamptee', slug: 'kamptee', population: 98432 },
  { name: 'Latur', slug: 'latur', population: 382754 },
  { name: 'Nagpur', slug: 'nagpur-maharashtra', population: 2405665 },
  { name: 'Nanded', slug: 'nanded', population: 550564 },
  { name: 'Nashik', slug: 'nashik-maharashtra', population: 1486973 },
  { name: 'Osmanabad', slug: 'osmanabad', population: 99657 },
  { name: 'Parbhani', slug: 'parbhani', population: 307191 },
  
  // Gujarat (150 ciudades)
  { name: 'Anand', slug: 'anand', population: 184527 },
  { name: 'Ankleshwar', slug: 'ankleshwar', population: 74832 },
  { name: 'Bharuch', slug: 'bharuch', population: 174072 },
  { name: 'Bhavnagar', slug: 'bhavnagar', population: 605882 },
  { name: 'Bhuj', slug: 'bhuj', population: 148731 },
  { name: 'Botad', slug: 'botad', population: 117161 },
  { name: 'Dahod', slug: 'dahod', population: 130530 },
  { name: 'Gandhidham', slug: 'gandhidham', population: 166665 },
  { name: 'Gandhinagar', slug: 'gandhinagar', population: 208299 },
  { name: 'Godhra', slug: 'godhra', population: 131186 },
  { name: 'Jamnagar', slug: 'jamnagar', population: 600943 },
  { name: 'Junagadh', slug: 'junagadh', population: 320250 },
  { name: 'Kalol', slug: 'kalol', population: 150376 },
  { name: 'Kandla', slug: 'kandla', population: 50000 },
  { name: 'Mehsana', slug: 'mehsana', population: 184991 },
  { name: 'Morbi', slug: 'morbi', population: 210451 },
  { name: 'Nadiad', slug: 'nadiad', population: 218095 },
  { name: 'Navsari', slug: 'navsari', population: 171109 },
  { name: 'Palanpur', slug: 'palanpur', population: 141592 },
  { name: 'Patan', slug: 'patan', population: 125776 },
  
  // West Bengal (150 ciudades)
  { name: 'Alipurduar', slug: 'alipurduar', population: 114038 },
  { name: 'Asansol', slug: 'asansol', population: 1243008 },
  { name: 'Baharampur', slug: 'baharampur', population: 270269 },
  { name: 'Balurghat', slug: 'balurghat', population: 169264 },
  { name: 'Bankura', slug: 'bankura', population: 138983 },
  { name: 'Barrackpore', slug: 'barrackpore', population: 144331 },
  { name: 'Basirhat', slug: 'basirhat', population: 113711 },
  { name: 'Bhatpara', slug: 'bhatpara', population: 441956 },
  { name: 'Bidhannagar', slug: 'bidhannagar', population: 218323 },
  { name: 'Burdwan', slug: 'burdwan', population: 394015 },
  { name: 'Chandernagore', slug: 'chandernagore', population: 166867 },
  { name: 'Cooch Behar', slug: 'cooch-behar', population: 100550 },
  { name: 'Durgapur', slug: 'durgapur', population: 566937 },
  { name: 'Haldia', slug: 'haldia', population: 200762 },
  { name: 'Jalpaiguri', slug: 'jalpaiguri', population: 107341 },
  { name: 'Kharagpur', slug: 'kharagpur', population: 293719 },
  { name: 'Krishnanagar', slug: 'krishnanagar', population: 153062 },
  { name: 'Malda', slug: 'malda', population: 216083 },
  { name: 'Midnapore', slug: 'midnapore', population: 169264 },
  { name: 'Purulia', slug: 'purulia', population: 164572 },
  
  // Tamil Nadu (150 ciudades)
  { name: 'Arakkonam', slug: 'arakkonam', population: 101626 },
  { name: 'Chengalpattu', slug: 'chengalpattu', population: 73313 },
  { name: 'Cuddalore', slug: 'cuddalore', population: 173676 },
  { name: 'Dindigul', slug: 'dindigul', population: 207327 },
  { name: 'Erode', slug: 'erode', population: 498129 },
  { name: 'Hosur', slug: 'hosur', population: 126376 },
  { name: 'Kanchipuram', slug: 'kanchipuram', population: 164384 },
  { name: 'Karur', slug: 'karur', population: 106565 },
  { name: 'Kumbakonam', slug: 'kumbakonam', population: 140156 },
  { name: 'Nagercoil', slug: 'nagercoil', population: 224329 },
  { name: 'Neyveli', slug: 'neyveli', population: 118080 },
  { name: 'Ooty', slug: 'ooty', population: 88430 },
  { name: 'Pallavaram', slug: 'pallavaram', population: 195804 },
  { name: 'Pollachi', slug: 'pollachi', population: 90180 },
  { name: 'Pudukkottai', slug: 'pudukkottai', population: 117944 },
  { name: 'Rajapalayam', slug: 'rajapalayam', population: 122313 },
  { name: 'Salem', slug: 'salem', population: 831038 },
  { name: 'Thanjavur', slug: 'thanjavur', population: 222943 },
  { name: 'Tirunelveli', slug: 'tirunelveli', population: 473637 },
  { name: 'Tiruppur', slug: 'tiruppur', population: 877778 },
  
  // Karnataka (150 ciudades)
  { name: 'Bagalkot', slug: 'bagalkot', population: 103417 },
  { name: 'Ballari', slug: 'ballari', population: 410445 },
  { name: 'Belagavi', slug: 'belagavi', population: 610350 },
  { name: 'Bengaluru', slug: 'bengaluru-karnataka', population: 8443675 },
  { name: 'Bidar', slug: 'bidar', population: 204073 },
  { name: 'Chamarajanagar', slug: 'chamarajanagar', population: 66537 },
  { name: 'Chikkaballapur', slug: 'chikkaballapur', population: 64043 },
  { name: 'Chikkamagaluru', slug: 'chikkamagaluru', population: 118401 },
  { name: 'Chitradurga', slug: 'chitradurga', population: 124462 },
  { name: 'Davanagere', slug: 'davanagere', population: 435128 },
  { name: 'Dharwad', slug: 'dharwad', population: 492804 },
  { name: 'Gadag', slug: 'gadag', population: 154306 },
  { name: 'Hassan', slug: 'hassan', population: 133436 },
  { name: 'Haveri', slug: 'haveri', population: 62380 },
  { name: 'Kalaburagi', slug: 'kalaburagi', population: 543147 },
  { name: 'Kolar', slug: 'kolar', population: 138472 },
  { name: 'Koppal', slug: 'koppal', population: 59899 },
  { name: 'Mandya', slug: 'mandya', population: 137358 },
  { name: 'Raichur', slug: 'raichur', population: 234073 },
  { name: 'Shivamogga', slug: 'shivamogga', population: 322650 },
  
  // Andhra Pradesh (150 ciudades)
  { name: 'Anantapur', slug: 'anantapur', population: 267161 },
  { name: 'Chittoor', slug: 'chittoor', population: 189332 },
  { name: 'Eluru', slug: 'eluru', population: 214414 },
  { name: 'Guntur', slug: 'guntur', population: 743654 },
  { name: 'Kadapa', slug: 'kadapa', population: 344893 },
  { name: 'Kakinada', slug: 'kakinada', population: 443028 },
  { name: 'Kurnool', slug: 'kurnool', population: 460184 },
  { name: 'Machilipatnam', slug: 'machilipatnam', population: 183370 },
  { name: 'Nellore', slug: 'nellore', population: 505258 },
  { name: 'Ongole', slug: 'ongole', population: 186595 },
  { name: 'Proddatur', slug: 'proddatur', population: 164776 },
  { name: 'Rajahmundry', slug: 'rajahmundry', population: 341831 },
  { name: 'Srikakulam', slug: 'srikakulam', population: 146583 },
  { name: 'Tadepalligudem', slug: 'tadepalligudem', population: 103906 },
  { name: 'Tenali', slug: 'tenali', population: 164937 },
  { name: 'Tirupati', slug: 'tirupati', population: 459985 },
  { name: 'Vizianagaram', slug: 'vizianagaram', population: 228025 },
  { name: 'Bhimavaram', slug: 'bhimavaram', population: 163336 },
  { name: 'Chirala', slug: 'chirala', population: 126583 },
  { name: 'Hindupur', slug: 'hindupur', population: 137031 },
  
  // Telangana (100 ciudades)
  { name: 'Adilabad', slug: 'adilabad', population: 116969 },
  { name: 'Bhongir', slug: 'bhongir', population: 164991 },
  { name: 'Jagtial', slug: 'jagtial', population: 99207 },
  { name: 'Jangaon', slug: 'jangaon', population: 67023 },
  { name: 'Kamareddy', slug: 'kamareddy', population: 93208 },
  { name: 'Karimnagar', slug: 'karimnagar', population: 261185 },
  { name: 'Khammam', slug: 'khammam', population: 262255 },
  { name: 'Mahbubnagar', slug: 'mahbubnagar', population: 147890 },
  { name: 'Mancherial', slug: 'mancherial', population: 87731 },
  { name: 'Medak', slug: 'medak', population: 49455 },
  { name: 'Miryalaguda', slug: 'miryalaguda', population: 100545 },
  { name: 'Nagarkurnool', slug: 'nagarkurnool', population: 57597 },
  { name: 'Nalgonda', slug: 'nalgonda', population: 135799 },
  { name: 'Nirmal', slug: 'nirmal', population: 99038 },
  { name: 'Nizamabad', slug: 'nizamabad', population: 311152 },
  { name: 'Peddapalli', slug: 'peddapalli', population: 77274 },
  { name: 'Ramagundam', slug: 'ramagundam', population: 236600 },
  { name: 'Sangareddy', slug: 'sangareddy', population: 101123 },
  { name: 'Siddipet', slug: 'siddipet', population: 90890 },
  { name: 'Suryapet', slug: 'suryapet', population: 102077 },
  
  // Kerala (100 ciudades)
  { name: 'Alappuzha', slug: 'alappuzha', population: 174164 },
  { name: 'Attingal', slug: 'attingal', population: 37654 },
  { name: 'Chalakudy', slug: 'chalakudy', population: 52524 },
  { name: 'Changanassery', slug: 'changanassery', population: 47485 },
  { name: 'Guruvayur', slug: 'guruvayur', population: 21143 },
  { name: 'Kannur', slug: 'kannur', population: 232486 },
  { name: 'Kasaragod', slug: 'kasaragod', population: 43251 },
  { name: 'Kayamkulam', slug: 'kayamkulam', population: 44349 },
  { name: 'Kochi', slug: 'kochi', population: 677381 },
  { name: 'Kollam', slug: 'kollam', population: 397419 },
  { name: 'Kottayam', slug: 'kottayam', population: 136812 },
  { name: 'Kozhikode', slug: 'kozhikode', population: 609224 },
  { name: 'Kunnamkulam', slug: 'kunnamkulam', population: 32634 },
  { name: 'Malappuram', slug: 'malappuram', population: 101386 },
  { name: 'Manjeri', slug: 'manjeri', population: 56918 },
  { name: 'Mattancherry', slug: 'mattancherry', population: 35000 },
  { name: 'Ottappalam', slug: 'ottappalam', population: 50654 },
  { name: 'Palakkad', slug: 'palakkad', population: 197637 },
  { name: 'Payyanur', slug: 'payyanur', population: 37491 },
  { name: 'Perinthalmanna', slug: 'perinthalmanna', population: 33266 },
  
  // Odisha (100 ciudades)
  { name: 'Angul', slug: 'angul', population: 115833 },
  { name: 'Balangir', slug: 'balangir', population: 88888 },
  { name: 'Balasore', slug: 'balasore', population: 139661 },
  { name: 'Barbil', slug: 'barbil', population: 71154 },
  { name: 'Baripada', slug: 'baripada', population: 118821 },
  { name: 'Berhampur', slug: 'berhampur', population: 356598 },
  { name: 'Bhadrak', slug: 'bhadrak', population: 105952 },
  { name: 'Bhubaneswar', slug: 'bhubaneswar', population: 881988 },
  { name: 'Boudh', slug: 'boudh', population: 21689 },
  { name: 'Byasanagar', slug: 'byasanagar', population: 69270 },
  { name: 'Cuttack', slug: 'cuttack', population: 663849 },
  { name: 'Dhenkanal', slug: 'dhenkanal', population: 85023 },
  { name: 'Jharsuguda', slug: 'jharsuguda', population: 94732 },
  { name: 'Kendrapara', slug: 'kendrapara', population: 57827 },
  { name: 'Kendujhar', slug: 'kendujhar', population: 45688 },
  { name: 'Koraput', slug: 'koraput', population: 42934 },
  { name: 'Nabarangpur', slug: 'nabarangpur', population: 53719 },
  { name: 'Paradip', slug: 'paradip', population: 75912 },
  { name: 'Phulbani', slug: 'phulbani', population: 20430 },
  { name: 'Puri', slug: 'puri', population: 200564 },
  
  // Assam (80 ciudades)
  { name: 'Barpeta', slug: 'barpeta', population: 50823 },
  { name: 'Bongaigaon', slug: 'bongaigaon', population: 58206 },
  { name: 'Cachar', slug: 'cachar', population: 127453 },
  { name: 'Dhemaji', slug: 'dhemaji', population: 18144 },
  { name: 'Dhubri', slug: 'dhubri', population: 67300 },
  { name: 'Dibrugarh', slug: 'dibrugarh', population: 154296 },
  { name: 'Diphu', slug: 'diphu', population: 62387 },
  { name: 'Guwahati', slug: 'guwahati-assam', population: 963429 },
  { name: 'Haflong', slug: 'haflong', population: 36014 },
  { name: 'Hailakandi', slug: 'hailakandi', population: 44185 },
  { name: 'Hojai', slug: 'hojai', population: 68398 },
  { name: 'Jorhat', slug: 'jorhat', population: 153889 },
  { name: 'Karimganj', slug: 'karimganj', population: 55007 },
  { name: 'Kokrajhar', slug: 'kokrajhar', population: 36009 },
  { name: 'Lakhimpur', slug: 'lakhimpur', population: 77899 },
  { name: 'Mangaldoi', slug: 'mangaldoi', population: 57653 },
  { name: 'Mariani', slug: 'mariani', population: 35543 },
  { name: 'Nagaon', slug: 'nagaon', population: 147231 },
  { name: 'Nalbari', slug: 'nalbari', population: 32441 },
  { name: 'North Lakhimpur', slug: 'north-lakhimpur', population: 57244 },
  
  // Jharkhand (80 ciudades)
  { name: 'Adityapur', slug: 'adityapur', population: 174979 },
  { name: 'Bokaro', slug: 'bokaro', population: 391403 },
  { name: 'Chaibasa', slug: 'chaibasa', population: 77710 },
  { name: 'Chakradharpur', slug: 'chakradharpur', population: 91169 },
  { name: 'Chatra', slug: 'chatra', population: 42132 },
  { name: 'Deoghar', slug: 'deoghar', population: 203116 },
  { name: 'Dhanbad', slug: 'dhanbad-jharkhand', population: 1161561 },
  { name: 'Dumka', slug: 'dumka', population: 53444 },
  { name: 'Garhwa', slug: 'garhwa', population: 84599 },
  { name: 'Giridih', slug: 'giridih', population: 154871 },
  { name: 'Godda', slug: 'godda', population: 40225 },
  { name: 'Gumla', slug: 'gumla', population: 39685 },
  { name: 'Hazaribagh', slug: 'hazaribagh', population: 142833 },
  { name: 'Jamshedpur', slug: 'jamshedpur', population: 629659 },
  { name: 'Jamtara', slug: 'jamtara', population: 24318 },
  { name: 'Khunti', slug: 'khunti', population: 21906 },
  { name: 'Koderma', slug: 'koderma', population: 32156 },
  { name: 'Latehar', slug: 'latehar', population: 16831 },
  { name: 'Lohardaga', slug: 'lohardaga', population: 31320 },
  { name: 'Pakur', slug: 'pakur', population: 17540 },
  
  // Haryana (80 ciudades)
  { name: 'Ambala', slug: 'ambala', population: 196216 },
  { name: 'Bahadurgarh', slug: 'bahadurgarh', population: 172928 },
  { name: 'Bhiwani', slug: 'bhiwani', population: 169424 },
  { name: 'Faridabad', slug: 'faridabad-haryana', population: 1404653 },
  { name: 'Gurugram', slug: 'gurugram', population: 876969 },
  { name: 'Hisar', slug: 'hisar', population: 301434 },
  { name: 'Jind', slug: 'jind', population: 172073 },
  { name: 'Kaithal', slug: 'kaithal', population: 151891 },
  { name: 'Karnal', slug: 'karnal', population: 286974 },
  { name: 'Kurukshetra', slug: 'kurukshetra', population: 156735 },
  { name: 'Mahendragarh', slug: 'mahendragarh', population: 62311 },
  { name: 'Mewat', slug: 'mewat', population: 79340 },
  { name: 'Palwal', slug: 'palwal', population: 139204 },
  { name: 'Panchkula', slug: 'panchkula', population: 211355 },
  { name: 'Panipat', slug: 'panipat', population: 441056 },
  { name: 'Rewari', slug: 'rewari', population: 143021 },
  { name: 'Rohtak', slug: 'rohtak', population: 373133 },
  { name: 'Sirsa', slug: 'sirsa', population: 181434 },
  { name: 'Sonipat', slug: 'sonipat', population: 279074 },
  { name: 'Yamunanagar', slug: 'yamunanagar', population: 383318 },
  
  // Chhattisgarh (60 ciudades)
  { name: 'Bhilai', slug: 'bhilai', population: 1064077 },
  { name: 'Bilaspur', slug: 'bilaspur-cg', population: 365579 },
  { name: 'Dhamtari', slug: 'dhamtari', population: 83030 },
  { name: 'Durg', slug: 'durg', population: 268806 },
  { name: 'Jagdalpur', slug: 'jagdalpur', population: 123138 },
  { name: 'Korba', slug: 'korba', population: 365073 },
  { name: 'Mahasamund', slug: 'mahasamund', population: 54754 },
  { name: 'Raigarh', slug: 'raigarh-cg', population: 135133 },
  { name: 'Raipur', slug: 'raipur-cg', population: 1010087 },
  { name: 'Rajnandgaon', slug: 'rajnandgaon', population: 163122 },
  { name: 'Ambikapur', slug: 'ambikapur', population: 116474 },
  { name: 'Bemetara', slug: 'bemetara', population: 24012 },
  { name: 'Bijapur', slug: 'bijapur-cg', population: 20516 },
  { name: 'Champa', slug: 'champa', population: 77469 },
  { name: 'Chirmiri', slug: 'chirmiri', population: 90294 },
  { name: 'Dongargarh', slug: 'dongargarh', population: 38604 },
  { name: 'Gaurela', slug: 'gaurela', population: 23423 },
  { name: 'Janjgir', slug: 'janjgir', population: 76321 },
  { name: 'Jashpur', slug: 'jashpur', population: 41114 },
  { name: 'Kanker', slug: 'kanker', population: 36742 },
  
  // Uttarakhand (60 ciudades)
  { name: 'Almora', slug: 'almora', population: 35513 },
  { name: 'Bageshwar', slug: 'bageshwar', population: 17184 },
  { name: 'Chamoli', slug: 'chamoli', population: 25980 },
  { name: 'Champawat', slug: 'champawat', population: 26154 },
  { name: 'Dehradun', slug: 'dehradun', population: 578420 },
  { name: 'Haridwar', slug: 'haridwar', population: 228832 },
  { name: 'Haldwani', slug: 'haldwani', population: 232060 },
  { name: 'Kashipur', slug: 'kashipur', population: 121623 },
  { name: 'Mussoorie', slug: 'mussoorie', population: 30118 },
  { name: 'Nainital', slug: 'nainital', population: 41377 },
  { name: 'Pauri Garhwal', slug: 'pauri-garhwal', population: 23118 },
  { name: 'Pithoragarh', slug: 'pithoragarh', population: 56876 },
  { name: 'Roorkee', slug: 'roorkee', population: 118473 },
  { name: 'Rudrapur', slug: 'rudrapur', population: 154485 },
  { name: 'Tehri', slug: 'tehri', population: 15570 },
  { name: 'Udham Singh Nagar', slug: 'udham-singh-nagar', population: 72898 },
  { name: 'Uttarkashi', slug: 'uttarkashi', population: 16890 },
  { name: 'Vikasnagar', slug: 'vikasnagar', population: 31020 },
  { name: 'Rishikesh', slug: 'rishikesh', population: 102138 },
  { name: 'Kichha', slug: 'kichha', population: 56348 },
  
  // Himachal Pradesh (60 ciudades)
  { name: 'Bilaspur', slug: 'bilaspur-hp', population: 13057 },
  { name: 'Chamba', slug: 'chamba', population: 20312 },
  { name: 'Dharamshala', slug: 'dharamshala', population: 30764 },
  { name: 'Hamirpur', slug: 'hamirpur-hp', population: 18846 },
  { name: 'Kangra', slug: 'kangra', population: 26882 },
  { name: 'Keylong', slug: 'keylong', population: 1400 },
  { name: 'Kinnaur', slug: 'kinnaur', population: 8000 },
  { name: 'Kullu', slug: 'kullu', population: 18306 },
  { name: 'Lahaul and Spiti', slug: 'lahaul-spiti', population: 31528 },
  { name: 'Mandi', slug: 'mandi', population: 26422 },
  { name: 'Shimla', slug: 'shimla', population: 169578 },
  { name: 'Sirmaur', slug: 'sirmaur', population: 15830 },
  { name: 'Solan', slug: 'solan', population: 39256 },
  { name: 'Una', slug: 'una-hp', population: 18541 },
  { name: 'Baddi', slug: 'baddi', population: 30516 },
  { name: 'Baijnath', slug: 'baijnath', population: 5741 },
  { name: 'Chail', slug: 'chail', population: 1500 },
  { name: 'Dalhousie', slug: 'dalhousie', population: 7419 },
  { name: 'Kasauli', slug: 'kasauli', population: 2112 },
  { name: 'Manali', slug: 'manali', population: 8096 },
  
  // Jammu and Kashmir (60 ciudades)
  { name: 'Anantnag', slug: 'anantnag', population: 108505 },
  { name: 'Baramulla', slug: 'baramulla', population: 71434 },
  { name: 'Budgam', slug: 'budgam', population: 35198 },
  { name: 'Doda', slug: 'doda', population: 21067 },
  { name: 'Ganderbal', slug: 'ganderbal', population: 13986 },
  { name: 'Jammu', slug: 'jammu', population: 502197 },
  { name: 'Kathua', slug: 'kathua', population: 60851 },
  { name: 'Kishtwar', slug: 'kishtwar', population: 18910 },
  { name: 'Kulgam', slug: 'kulgam', population: 23584 },
  { name: 'Kupwara', slug: 'kupwara', population: 37359 },
  { name: 'Leh', slug: 'leh', population: 30870 },
  { name: 'Poonch', slug: 'poonch', population: 26566 },
  { name: 'Pulwama', slug: 'pulwama', population: 30556 },
  { name: 'Rajouri', slug: 'rajouri', population: 52621 },
  { name: 'Ramban', slug: 'ramban', population: 21620 },
  { name: 'Reasi', slug: 'reasi', population: 21492 },
  { name: 'Samba', slug: 'samba', population: 25869 },
  { name: 'Shopian', slug: 'shopian', population: 10826 },
  { name: 'Srinagar', slug: 'srinagar-jk', population: 1180570 },
  { name: 'Udhampur', slug: 'udhampur', population: 62662 }
];

// Exportar también como expansión completa
export const indiaExpansion3 = {
  code: 'IN',
  name: 'India',
  slug: 'india',
  population: 1380000000,
  topCities: [
    { name: 'Mumbai', slug: 'mumbai', population: 20411274 },
    { name: 'Delhi', slug: 'delhi', population: 16787941 },
    { name: 'Bangalore', slug: 'bangalore', population: 8443675 },
    { name: 'Hyderabad', slug: 'hyderabad', population: 6809970 },
    { name: 'Ahmedabad', slug: 'ahmedabad', population: 5570585 },
    { name: 'Chennai', slug: 'chennai', population: 4681087 },
    { name: 'Kolkata', slug: 'kolkata', population: 4496694 },
    { name: 'Surat', slug: 'surat', population: 4467797 },
    { name: 'Pune', slug: 'pune', population: 3124458 },
    { name: 'Jaipur', slug: 'jaipur', population: 3046163 },
    ...indiaAdditionalCities3
  ]
};
